export const navLinks = [
  { id: "overview", label: "影片速览" },
  { id: "story", label: "剧情与主题" },
  { id: "playlines", label: "播放线路" },
  { id: "versions", label: "版本对比" },
  { id: "guide", label: "观看指南" },
  { id: "faq", label: "常见问题" },
  { id: "more", label: "延伸推荐" },
  { id: "notice", label: "说明" },
];

export const heroChips = [
  "在线观看",
  "在线播放",
  "高清在线",
  "免费在线",
  "完整版",
  "无删减",
];

export const quickFacts = [
  { icon: "ri-play-circle-line", label: "播放形式", value: "网页在线播放" },
  { icon: "ri-hd-line", label: "清晰度", value: "标清 / 高清在线" },
  { icon: "ri-file-list-3-line", label: "资源版本", value: "完整版 · 无删减" },
  { icon: "ri-device-line", label: "支持设备", value: "手机 / 平板 / 电脑" },
  { icon: "ri-translate-2", label: "字幕语言", value: "简体中文" },
  { icon: "ri-price-tag-3-line", label: "观看费用", value: "免费在线浏览" },
];

export const storyPoints = [
  {
    icon: "ri-home-heart-line",
    title: "家庭日常作为起点",
    desc: "故事从最平常的一家人开始，把镜头放在客厅、餐桌与走廊这些熟悉的空间里，让人物的关系在生活细节中慢慢展开。",
  },
  {
    icon: "ri-emotion-line",
    title: "围绕关照与误会",
    desc: "善良与误解常常同时出现。角色出于好意做出的选择，被家人以另一种方式解读，于是冲突在温和的语境里逐渐累积。",
  },
  {
    icon: "ri-scales-3-line",
    title: "分寸与边界",
    desc: "作品反复触碰一个话题：在亲密关系里，关心与越界之间只有很薄的一层。每个人物都要为自己的分寸做出解释。",
  },
  {
    icon: "ri-sun-line",
    title: "克制的情绪表达",
    desc: "情绪并不靠激烈台词堆叠，而是借沉默、停顿与眼神完成。观众常常要到下一场戏，才明白上一幕真正发生了什么。",
  },
];

export const playLines = [
  {
    id: "line-a",
    name: "线路一 · 标准在线",
    badge: "推荐",
    quality: "高清 720P",
    speed: "加载较快",
    devices: "电脑 / 手机",
    note: "适合网络一般的用户，起播速度快，拖动进度条后缓冲时间短，是日常浏览的默认选择。",
    tags: ["秒开", "省流量", "全设备"],
  },
  {
    id: "line-b",
    name: "线路二 · 高清增强",
    badge: "高清",
    quality: "高清 1080P",
    speed: "加载中等",
    devices: "电脑 / 平板",
    note: "画面细节更完整，适合在较大屏幕上观看。对网络速度有一定要求，建议使用稳定的网络环境。",
    tags: ["更清晰", "大屏友好", "色彩准确"],
  },
  {
    id: "line-c",
    name: "线路三 · 完整无删减",
    badge: "完整版",
    quality: "高清 1080P",
    speed: "加载稍慢",
    devices: "电脑",
    note: "保留完整内容与完整片长，节奏更连贯。适合希望一次看完完整版、在意连贯性的用户。",
    tags: ["完整片长", "内容连贯", "无删减"],
  },
];

export const versions = [
  {
    id: "hd",
    name: "高清在线",
    subtitle: "适合日常浏览",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20warm%20amber%20light%20rays%20through%20soft%20smoke%20on%20dark%20brown%20background%2C%20moody%20film%20grain%2C%20minimalist%20vertical%20poster%20style%2C%20ornamental%20curtain%20silhouette%2C%20warm%20golden%20tone%20photography&width=800&height=1000&seq=version-hd-2026&orientation=portrait",
    features: ["起播速度快", "适配移动端", "画面明亮清晰"],
    highlight: false,
  },
  {
    id: "free",
    name: "免费在线",
    subtitle: "无需额外步骤",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20deep%20terracotta%20and%20cream%20fabric%20folds%20with%20soft%20window%20shadow%2C%20quiet%20interior%20mood%2C%20matte%20texture%2C%20minimalist%20vertical%20poster%20style%2C%20warm%20earthy%20tone%20photography&width=800&height=1000&seq=version-free-2026&orientation=portrait",
    features: ["直接在线播放", "支持全设备", "可随时切换线路"],
    highlight: true,
  },
  {
    id: "full",
    name: "完整版 · 无删减",
    subtitle: "在意连贯性时选择",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20long%20corridor%20with%20warm%20lamp%20glow%20and%20deep%20shadows%2C%20olive%20and%20brown%20palette%2C%20film%20noir%20atmosphere%2C%20minimalist%20vertical%20poster%20style%2C%20warm%20muted%20tone%20photography&width=800&height=1000&seq=version-full-2026&orientation=portrait",
    features: ["完整片长", "内容无删减", "叙事更连贯"],
    highlight: false,
  },
];

export const watchSteps = [
  {
    step: "01",
    icon: "ri-search-line",
    title: "确认想看的版本",
    desc: "先想清楚这次是想快速浏览，还是想一次看完完整内容。版本决定了后面该选择哪条线路，也让观看预期更清楚。",
  },
  {
    step: "02",
    icon: "ri-route-line",
    title: "挑选合适线路",
    desc: "网络一般时优先选择加载较快的一条；使用大屏或在意画质时，再切换到高清增强的线路。",
  },
  {
    step: "03",
    icon: "ri-settings-3-line",
    title: "调整播放设置",
    desc: "开始播放后，可根据设备调整音量与字幕大小，横屏观看通常能得到更完整的画面比例。",
  },
  {
    step: "04",
    icon: "ri-restart-line",
    title: "遇卡顿就换线",
    desc: "如果出现长时间缓冲，直接切换到另一条线路即可，不必反复刷新页面，免去重新寻找位置。",
  },
];

export const faqs = [
  {
    q: "为什么打开后没有立刻开始播放？",
    a: "浏览器需要先加载一小段内容才能顺利起播，通常几秒内即可开始。若长时间停留在加载状态，可以切换到另一条播放线路再试一次。",
  },
  {
    q: "高清在线和完整版的差别在哪里？",
    a: "高清在线更强调清晰度与起播速度，适合日常浏览；完整版则保留完整片长与连贯内容，适合希望不被打断看完整个故事的用户。",
  },
  {
    q: "在手机上观看需要注意什么？",
    a: "建议使用较新的浏览器并保持横屏播放，画面比例会更完整。同时注意调整音量，避免在需要保持安静的场合外放。",
  },
  {
    q: "切换线路会丢失播放进度吗？",
    a: "不同线路各自保存自己的进度，切换后可能需要重新定位到之前的位置。建议在一个线路内观看完整段落再切换。",
  },
  {
    q: "页面上的内容会一直变化吗？",
    a: "页面信息会随着资源整理情况调整，版本与线路说明以当前页面展示为准。若发现说明与实际情况不一致，可以以页面最新的提示为参考。",
  },
];

export const recommendTags = ["全部", "家庭", "剧情", "治愈", "悬疑", "日常"];

export const recommendations = [
  {
    id: "rec-1",
    title: "类似家庭题材的在线观看合集",
    desc: "围绕亲情与相处展开的在线观看整理，适合在看完本片后继续浏览同类型内容。",
    tags: ["家庭", "剧情"],
    meta: "在线观看 · 完整版",
    image:
      "https://readdy.ai/api/search-image?query=warm%20family%20dining%20table%20with%20soft%20lamp%20light%20and%20ceramic%20bowls%2C%20cozy%20interior%20scene%2C%20muted%20amber%20and%20cream%20palette%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=rec-family-2026&orientation=landscape",
  },
  {
    id: "rec-2",
    title: "情绪克制的剧情片推荐",
    desc: "台词不多、情绪靠细节传递的剧情作品，适合喜欢慢慢体会人物心理的观众。",
    tags: ["剧情", "治愈"],
    meta: "高清在线 · 1080P",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20empty%20room%20with%20afternoon%20sunlight%20across%20wooden%20floor%2C%20dust%20particles%20in%20light%2C%20warm%20minimal%20interior%2C%20muted%20earth%20palette%2C%20editorial%20photography&width=800&height=600&seq=rec-drama-2026&orientation=landscape",
  },
  {
    id: "rec-3",
    title: "适合夜晚观看的慢节奏短片",
    desc: "篇幅不长、节奏舒缓的短片集合，适合在睡前一小时安静地看完一部。",
    tags: ["治愈", "日常"],
    meta: "免费在线 · 标清",
    image:
      "https://readdy.ai/api/search-image?query=dim%20cozy%20room%20at%20night%20with%20single%20warm%20lamp%20and%20sheer%20curtain%2C%20deep%20brown%20shadows%2C%20calm%20atmosphere%2C%20muted%20amber%20palette%2C%20editorial%20photography&width=800&height=600&seq=rec-night-2026&orientation=landscape",
  },
  {
    id: "rec-4",
    title: "围绕误会的都市故事",
    desc: "故事由一次小小的误会展开，人物在彼此解释与沉默之间来回，节奏轻快。",
    tags: ["剧情", "悬疑"],
    meta: "在线播放 · 高清",
    image:
      "https://readdy.ai/api/search-image?query=rainy%20city%20window%20with%20warm%20street%20light%20reflections%2C%20soft%20bokeh%2C%20muted%20olive%20and%20brown%20palette%2C%20moody%20editorial%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=rec-city-2026&orientation=landscape",
  },
  {
    id: "rec-5",
    title: "日常轻喜剧一览",
    desc: "以轻松方式讲述家人相处的作品，笑点建立在生活细节上，观看起来没有负担。",
    tags: ["日常", "家庭", "治愈"],
    meta: "免费在线 · 标清",
    image:
      "https://readdy.ai/api/search-image?query=bright%20cheerful%20kitchen%20corner%20with%20fresh%20fruit%20and%20warm%20morning%20light%2C%20clean%20cream%20and%20amber%20palette%2C%20lifestyle%20editorial%20photography%2C%20airy%20composition&width=800&height=600&seq=rec-comedy-2026&orientation=landscape",
  },
  {
    id: "rec-6",
    title: "高分口碑剧情整理",
    desc: "口碑较集中的剧情类作品整理，适合想按评价挑选内容的观众依次浏览。",
    tags: ["剧情", "悬疑"],
    meta: "高清在线 · 1080P",
    image:
      "https://readdy.ai/api/search-image?query=dark%20elegant%20study%20with%20stacked%20books%20and%20warm%20desk%20lamp%2C%20deep%20brown%20tones%2C%20quiet%20scholarly%20mood%2C%20muted%20palette%2C%20editorial%20photography&width=800&height=600&seq=rec-top-2026&orientation=landscape",
  },
];

export const noticePoints = [
  {
    icon: "ri-information-line",
    title: "信息以页面为准",
    desc: "本页用于整理与主题相关的在线观看、播放与版本说明，页面内容会随资源整理情况更新，具体以当前展示为准。",
  },
  {
    icon: "ri-shield-check-line",
    title: "理性安排观看时间",
    desc: "建议合理安排浏览与休息时间，保持环境安静、音量适中，避免影响他人或自身的作息。",
  },
  {
    icon: "ri-user-heart-line",
    title: "尊重内容与版权",
    desc: "页面仅作信息整理与导航说明。如涉及版权问题，请通过正规渠道获取授权内容，并遵守当地相关法律法规。",
  },
];